<section class="section py-6">
    <div class="columns">
      <div class="column header-title-page">
        <h2 class="title-header">Producto - Mixtion</h2>
        <div>
          <button class="button is-primary mr-2" (click)="openModal()">Nuevo producto - mixtion</button>
          <button class="button is-primary mr-2" (click)="openUploadModal()">
            <fa-icon [icon]="faUpload" class="mr-2"></fa-icon>
            Importar datos
          </button>
          <button class="button is-primary" (click)="downloadExcel()" [disabled]="!productsFiltered?.length">
            <fa-icon [icon]="faDownload" class="mr-2"></fa-icon>
            Exportar datos
          </button>
        </div>
      </div>
    </div>
    <div class="columns">
        <div class="column is-6">
          <div class="field">
            <label class="label">Buscar</label>
            <p class="control has-icons-left">
              <input class="search-bar input" type="text" placeholder="Buscar..."[(ngModel)]="filters.search.value"
              (keyup.enter)="onFilter()">
              <span class="icon is-left">
                <fa-icon class="icon-search" [icon]="faMagnifyingGlass"></fa-icon>
              </span>
            </p>
          </div>
        </div>
      </div>
  </section>
  <section class="section py-1">
    <div class="columns has-background-white">
      <div class="column">
        <div class="columns">
          <div class="column p-5">
            @if (products) {
                <div class="table-reactors">
                  <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="productsFiltered" (onSelectRow)="openModal($event)"
                    (onDeleteItem)="delete($event)"></app-generic-table>
                </div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="modal" [ngClass]="{'is-active': isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <form [formGroup]="form" (ngSubmit)="onSave()">
        <header class="modal-card-head">
            @if (isCreating) {
            <p class="modal-card-title">Nuevo Producto - Mixtion</p>
            } @else {
            <p class="modal-card-title">Producto - Mixtion: {{ form.value.grad }}</p>
            }

          <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="label">Grad</label>
                    <div class="control">
                    <input class="input" type="text" placeholder="Grad" formControlName="grad">
                    </div>
                </div>
                <div class="field">
                    <label class="label">Nombre</label>
                    <div class="control">
                    <input class="input" type="text" placeholder="Nombre" formControlName="name">
                    </div>
                </div>
              <div class="field">
                <label class="label">Mixtion</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Mixtion" formControlName="mixtion">
                </div>
              </div>
              <div class="field">
                <label class="label">% Cantidad MP</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Cantidad MP" formControlName="cantidadMP">
                </div>
              </div>
              
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
          <button type="button" class="button" (click)="closeModal()">Cancelar</button>
          <button type="submit" class="button is-primary" [disabled]="!form.valid">
            @if(isLoading) {
            <fa-icon [icon]="faSpinner"></fa-icon>
            } @else {
                <span>Guardar</span>
            }
          </button>
        </footer>
      </form>
    </div>
  </div>

  <!-- Modal de carga de Excel -->
  <div class="modal" [ngClass]="{'is-active': isUploadModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card import-modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Importar datos desde archivo</p>
        <button type="button" class="delete" aria-label="close" (click)="closeUploadModal()"></button>
      </header>
      <section class="modal-card-body">
        <div class="steps pb-5">
          @if (uploadSteps) {
            <app-upload-apo-steps [steps]="uploadSteps" (onSelectTab)="onSelectUploadTab($event)"></app-upload-apo-steps>
          }
        </div>

        @if(selectedUploadStep === 'upload') {
          <div class="upload-file">
            @if(isUploading) {
              <div class="has-text-centered py-6">
                <fa-icon [icon]="faSpinner" [animation]="'spin'" class="fa-2x"></fa-icon>
                <p class="mt-3">Cargando archivo...</p>
              </div>
            } @else {
              <app-file-upload (onUploadFile)="onFileSelected($event)"></app-file-upload>
            }
          </div>
        }

        @if(selectedUploadStep === 'validate') {
          <div class="validate-data">
            @if(isUploading) {
              <div class="has-text-centered py-6">
                <fa-icon [icon]="faSpinner" [animation]="'spin'" class="fa-2x"></fa-icon>
                <p class="mt-3">Validando registros...</p>
              </div>
            } @else {
              @if (validatedData) {
                <div class="table-reactors">
                  <table class="table is-fullwidth is-striped is-hoverable">
                    <thead>
                      <tr>
                        <th>Grad</th>
                        <th>Nombre</th>
                        <th>Mixtion</th>
                        <th>% Cantidad MP</th>
                        <th>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (validatedData.processedRows && validatedData.processedRows.length > 0) {
                        @for (row of validatedData.processedRows; track $index) {
                          <tr [ngClass]="{
                            'status-new': row.status === 'NEW',
                            'status-updated': row.status === 'UPDATED',
                            'status-unchanged': row.status === 'UNCHANGED',
                            'status-deleted': row.status === 'DELETED'
                          }">
                            <td>{{ row.grad }}</td>
                            <td>{{ row.name }}</td>
                            <td>{{ row.mixtion }}</td>
                            <td>{{ row.cantidadMP ?? '-' }}</td>
                            <td>
                              @if (row.status === 'NEW') {
                                Nuevo
                              } @else if (row.status === 'UPDATED') {
                                Actualizado
                              } @else if (row.status === 'UNCHANGED') {
                                Sin cambios
                              } @else if (row.status === 'DELETED') {
                                Eliminado
                              }
                            </td>
                          </tr>
                        }
                      } @else {
                        <tr>
                          <td class="has-text-centered" colspan="5">No hay datos para mostrar</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              } @else {
                <div class="has-text-centered py-6">
                  <p>No hay datos para validar</p>
                </div>
              }
            }
          </div>
        }
      </section>
      <footer class="modal-card-foot is-justify-content-space-between">
        <button type="button" class="button" (click)="closeUploadModal()">Cancelar</button>
        @if(selectedUploadStep === 'validate') {
          <button 
            type="button" 
            class="button is-primary" 
            [disabled]="!validatedData || isUploading"
            (click)="confirmUpload()">
            @if(isUploading) {
              <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
            } @else {
              <span>Confirmar y guardar</span>
            }
          </button>
        }
      </footer>
    </div>
  </div>
